// Danish stopwords
// http://www.ranks.nl/stopwords/danish
// https://github.com/dnohr

module.exports = {
    stopwords: [
		"ad",
		"af",
		"aldrig",
		"alle",
		"alt",
		"altid",
		"anden",
		"andet",
		"andre",
		"at",
		"bagved",
		"begge",
		"blev",
		"blive",
		"bliver",
		"da",
		"de",
		"dem",
		"den",
		"denne",
		"der",
		"deres",
		"det",
		"dette",
		"dig",
		"din",
		"disse",
		"dog",
		"du",
		"efter",
		"ej",
		"eller",
		"en",
		"end",
		"endnu",
		"ene",
		"eneste",
		"enhver",
		"er",
		"et",
		"fem",
		"fire",
		"fjernt",
		"flere",
		"fleste",
		"for",
		"foran",
		"fordi",
		"forrige",
		"fra",
		"få",
		"før",
		"gennem",
		"god",
		"ham",
		"han",
		"hans",
		"har",
		"havde",
		"have",
		"hende",
		"hendes",
		"her",
		"hos",
		"hovfor",
		"hun",
		"hurtig",
		"hvad",
		"hvem",
		"hver",
		"hvilken",
		"hvis",
		"hvonår",
		"hvor",
		"hvordan",
		"hvorfor",
		"hvorhen",
		"hvornår",
		"i",
		"ikke",
		"imod",
		"ind",
		"ingen",
		"intet",
		"ja",
		"jeg",
		"jer",
		"jeres",
		"jo",
		"kan",
		"kom",
		"kommer",
		"kunne",
		"langsom",
		"lav",
		"lidt",
		"lille",
		"man",
		"mand",
		"mange",
		"med",
		"meget",
		"mellem",
		"men",
		"mens",
		"mere",
		"mig",
		"min",
		"mindre",
		"mine",
		"mit",
		"mod",
		"måske",
		"ned",
		"nede",
		"nej",
		"ni",
		"nogen",
		"noget",
		"nogle",
		"nok",
		"nu",
		"ny",
		"nyt",
		"når",
		"nær",
		"næste",
		"næsten",
		"og",
		"også",
		"om",
		"op",
		"oppe",
		"os",
		"otte",
		"over",
		"på",
		"rask",
		"sammen",
		"se",
		"seks",
		"selv",
		"ses",
		"sig",
		"sin",
		"sine",
		"sit",
		"skal",
		"skulle",
		"som",
		"stor",
		"store",
		"syv",
		"sådan",
		"temmelig",
		"thi",
		"ti",
		"til",
		"to",
		"tre",
		"ud",
		"uden",
		"udenfor",
		"under",
		"var",
		"ved",
		"vi",
		"vil",
		"ville",
		"vor",
		"være",
		"været"
    ]
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/lib/stopwords/da.js
 ** module id = 2978
 ** module chunks = 0
 **/